import { Attention, LabelColumnV2, LinkColumnV2, Overdue } from "../../../../components/DataGridV2/DataColumnsV2";
import { Box, Typography } from "@mui/material";
import { PriorityHigh, Schedule } from "@mui/icons-material";
import { getGridContextMenuList } from "../../../../_helpers/getGridContextMenuList";
import { formatDate, resolverStatus } from "../../../../_helpers";
import { LOCAL_STORAGE_GRID_KEYS } from "../../../../_constants";

export const getSecondSignatureRepairRequestWorkOrderColumns = ({
    t,
    keyPrefix,
    i18n,
    apiRef,
}) => {
    const getOptions = getGridContextMenuList({
          filterKey: LOCAL_STORAGE_GRID_KEYS.SECOND_SIGNATURE_REPAIR_REQUEST_WORK_ORDERS_COLUMN_FILTER[keyPrefix],
          sortKey: LOCAL_STORAGE_GRID_KEYS.SECOND_SIGNATURE_REPAIR_REQUEST_WORK_ORDERS_COLUMN_SORT[keyPrefix],
          i18n,
          t,
          apiRef,
          mode: "client",
          getValueForFilter: (rowData, extraData) => {
              let value = ""
              switch (extraData.fieldName) {
                  case "isRequiredHandling":
                      value = rowData?.isRequiredHandling?.toString()
                      break;
                  default:
                      value = rowData?.[extraData?.fieldName]
                      break;
              }
              return value
          },
          getValueForCopy: (rowData, extraData) => {
              let text = ""
              switch (extraData.fieldName) {
                  case "status":
                      text = t(`resolver.status.${rowData?.status}`)
                      break;
                  case "targetCompletionDate":
                      text = rowData?.targetCompletionDate ? formatDate(new Date(rowData?.targetCompletionDate)) : ""
                      break;
                  default:
                      text = rowData?.[extraData?.fieldName]
                      break;
              }
              return text
          }
      })
   
    return [
            {
                download: false,
                print: true,
                field: "isRequiredHandling",
                headerName: t("general.attention.label"),
                maxWidth: 45,
                minWidth: 45,
                forceApplyWidth: true,
                resizable: false,
                sortable: false,
                flex: 1,
                type: "boolean",
                renderHeader: () => (
                    <Box sx={{
                        mr: 0.6
                    }}>
                        <PriorityHigh color="secondary" size="small" />
                    </Box>
                ),
                renderCell: (params) => {
                    const request = params.row;
                    return (
                        <Attention rowData={request} t={t} options={getOptions({ sortable: false, field: "isRequiredHandling", isQuickFilterDisplay: Boolean(request.isRequiredHandling) })} />
                    );
                },
            },
        {
            download: false,
            print: true,
            field: "overdue",
            headerName: t("general.overdue"),
            maxWidth: 45,
            minWidth: 45,
            forceApplyWidth: true,
            resizable: false,
            sortable: false,
            flex: 1,
            type: "boolean",
            renderHeader: () => (
                <Box sx={{
                    mr: 0.6
                }}>
                    <Schedule size="small" />
                </Box>
            ),
            renderCell: (params) => {
                const request = params.row;
                return (
                    <Overdue rowData={request} t={t} options={getOptions({ sortable: false, field: "overdue", isQuickFilterDisplay: typeof request.overdue === "boolean" })} />
                );
            },
        },
        {
                download: true,
                print: true,
                field: "targetCompletionDate",
                headerName: t("repairRequest.targetCompletionDate.shortLabel"),
                flex: 1,
                minWidth: 90,
                type: "date",
                valueGetter: (params) => {
                    if (!params) return "";
                    return new Date(params);
                },
                renderCell: (params) => {
                    const rowData = params.row;
                    if (!rowData) return "";
                    return (
                        <LabelColumnV2
                            date={rowData.targetCompletionDate}
                            cellSubMenuOptions={{ options: getOptions({ field: "targetCompletionDate", isQuickFilterDisplay: Boolean(rowData.targetCompletionDate) }), extraData: { fieldName: "targetCompletionDate", type: "date" } }}
                            request={rowData}
                        />
                    );
                },
            },
            {
                download: true,
                print: true,
                field: "workOrderNumber",
                headerName: t("general.number"),
                flex: 1,
                minWidth: 108,
                renderCell: (params) => {
                    const rowData = params.row;
                    if (!rowData) return "";
                    return (
                        <LinkColumnV2
                            to={'#'}
                            label={<Typography variant='caption' sx={{ textTransform: 'none' , color:'primary'}}> {!rowData.workOrderNumber ? t("general.draft") : rowData.workOrderNumber}</Typography>}
                            cellSubMenuOptions={{ options: getOptions({ field: "workOrderNumber", isQuickFilterDisplay: Boolean(rowData.workOrderNumber) }), extraData: { fieldName: "workOrderNumber" } }}
                            request={rowData}
                        />
                    );
                },
            },
            {
                download: true,
                print: true,
                field: "name",
                headerName: t("general.resolver"),
                flex: 1,
                minWidth: 90,
                renderCell: (params) => {
                    const rowData = params.row;
                    return (
                        <LabelColumnV2
                            label={rowData.name}
                            cellSubMenuOptions={{ options: getOptions({ field: "name", isQuickFilterDisplay: Boolean(rowData.name) }), extraData: { fieldName: "name" } }}
                            request={rowData}
                        />
                    );
                },
            },
            {
                download: true,
                print: true,
                field: "status",
                headerName: t("general.status"),
                type: "singleSelect",
                valueOptions: Object.values(resolverStatus).map((resolverStatusKey) => ({ value: resolverStatusKey, label: t(`resolver.status.${resolverStatusKey}`) })),
                minWidth: 150,
                renderCell: (params) => {
                    const rowData = params.row;
                    const status = rowData.status
                    const translatedStatus =
                        status >= 0 && status <= 4
                            ? t("resolver.status." + status)
                            : "";
    
                    return (
                        <LabelColumnV2
                            label={translatedStatus}
                            cellSubMenuOptions={{
                                options: getOptions({
                                    field: "status",
                                    isQuickFilterDisplay: Boolean(translatedStatus.toString()),
                                }),
                                extraData: { fieldName: "status", type: 'singleSelect' },
                            }}
                            request={rowData}
                        />
                    );
                },
            }
    
        ];
}

